import { render, staticRenderFns } from "./AlarmQueueFilterTabs.vue?vue&type=template&id=0cd427cc"
import script from "./AlarmQueueFilterTabs.vue?vue&type=script&lang=ts"
export * from "./AlarmQueueFilterTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports